import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Input } from '../../../../../library/input'
import { Select } from '../../../../../library/select'
import { countries } from '../../../../../../resources/countries.json'
import { useDispatch, useSelector } from 'react-redux'
import './style.scss'

const Index = ({companyDetails, setCompanyDetails}) => {

    const renderCountries = () => {
		const items = [
			{
				id: 0,
				value: "",
				title: "Velg",
				selected: true,
				disabled: false
			}
		]
		countries.map((country, index) => {
			items.push({
				id: index + 1,
				value: country.code,
				title: country.title,
				selected: companyDetails.country === country.code ? true:false,
				disabled: false
			})
		})
		return items
	}

    return(
        <div className="dashboard-company-settings-form">
            <Row className="detail-row my-auto">
                <Col md={2} className="label-col my-auto">
                    <label className="field-label">Bedriftsnavn</label>
                </Col>
                <Col md={10} className="input-col my-auto">
                    <Input placeholder="Bedriftsnavn" value={companyDetails.name} onChange={(e) => setCompanyDetails({...companyDetails, name: e.target.value})}/>
                </Col>
            </Row>
            <Row className="detail-row my-auto">
                <Col md={2} className="label-col my-auto">
                    <label className="field-label">E-postadresse</label>
                </Col>
                <Col md={10} className="input-col my-auto">
                    <Input placeholder="E-postadresse" value={companyDetails.email} onChange={(e) => setCompanyDetails({...companyDetails, email: e.target.value})}/>
                </Col>
            </Row>
            <Row className="detail-row my-auto">
                <Col md={2} className="label-col my-auto">
                    <label className="field-label">Bransje</label>
                </Col>
                <Col md={10} className="input-col my-auto">
                    <Input placeholder="Adresse" value={companyDetails.industry} onChange={(e) => setCompanyDetails({...companyDetails, industry: e.target.value})}/>
                </Col>
            </Row>
            <hr/>
            <Row className="detail-row my-auto">
                <Col md={2} className="label-col my-auto">
                    <label className="field-label">Land</label>
                </Col>
                <Col md={10} className="input-col my-auto">
                    <Select onChange={(e) => setCompanyDetails({...companyDetails, country: {...companyDetails, country: e.target.value}})} items={renderCountries()}/>
                </Col>
            </Row>
            <Row className="detail-row my-auto">
                <Col md={2} className="label-col my-auto">
                    <label className="field-label">Gate</label>
                </Col>
                <Col md={10} className="input-col my-auto">
                    <Input placeholder="Addresse" value={companyDetails.street} onChange={(e) => setCompanyDetails({...companyDetails, street: e.target.value})}/>
                </Col>
            </Row>
            <Row className="detail-row my-auto">
                <Col md={2} className="label-col my-auto">
                    <label className="field-label">Postnummer</label>
                </Col>
                <Col md={10} className="input-col my-auto">
                    <Input placeholder="Postnummer" value={companyDetails.postalCode} onChange={(e) => setCompanyDetails({...companyDetails, postalCode: e.target.value})}/>
                </Col>
            </Row>
            <Row className="detail-row my-auto">
                <Col md={2} className="label-col my-auto">
                    <label className="field-label">By</label>
                </Col>
                <Col md={10} className="input-col my-auto">
                    <Input placeholder="By" value={companyDetails.city} onChange={(e) => setCompanyDetails({...companyDetails, city: e.target.value})}/>
                </Col>
            </Row>
        </div>
    )
}

export default Index